// extracted by mini-css-extract-plugin
module.exports = {"container":"kvWmsX3W","pillWrapper":"xU0N5Jzs","iconWrapper":"DYp7taYc","titleLabel":"yGAHTwmU","styledScenarioIcon":"p2DnkvfZ","metadataText":"I3S781oG"};